
import { KngTableState } from './definitions';

export class KngTableFactory 
{
	public static build(): KngTableState 
	{
		return {
			gridData: [],
			gridHeaders: [],
			isCheckbox: false,
			isRibbon: false,
			itemsSelected: '0',
			ribbon: {
				cancelButton: {
					size: 'medium',
					style: 'link',
					disabled: false,
					label: 'Cancel',
					icon: {
						altText: '',
						iconPath: ''
					},
					position: 'none'
				},
				ctaList: []
			},
			loading: true,
			noResult: {
				image: {
					altText: '',
					iconPath: ''
				},
				text: ''
			},
			approveUserLimitIndicatorText: ''
		};
	}
}
